<script setup lang="ts">
import { computed } from 'vue'
import StoresListView from './StoresListView.vue'
import StoreListViewAxe from './StoreListViewAxe.vue'
import { RoleService } from '@/services'

const roleService = new RoleService()

const isAxeOnly = computed(() => {
  return (
    roleService.hasRole('axe') &&
    !roleService.hasRole('vidacorp') &&
    !roleService.hasRole('arrotex')
  )
})
</script>

<template>
  <component :is="isAxeOnly ? StoreListViewAxe : StoresListView" />
</template>
